import * as React from "react";
import { Button, Col, Popover, Row } from "antd";
import { TIndexTypeGroupPresentationModel } from "../../presenter/model/IndexTypeGroupPresentationModel";

const TreeNodeTitle = ({
  translate,
  item,
  group,
  changeCreateGroupModalVisible,
  changeCreateItemModalVisible,
  style,
  childGroups,
  canEdit
}: {
  translate;
  item: TIndexTypeGroupPresentationModel;
  group;
  changeCreateGroupModalVisible;
  changeCreateItemModalVisible;
  style?: any;
  childGroups: TIndexTypeGroupPresentationModel[];
  canEdit: any;
}) => {
  return (
    <Row className={"png-tree-main-node-wrapper"}>
      <div className={"png-tree-main-node"} style={style}>
        {group.nameTranslation ?? group.name}
      </div>
      {canEdit() && (
        <Popover
          placement="top"
          content={
            <Col>
              {childGroups?.map((childGroup) => (
                <Button
                  onClick={() => {
                    changeCreateGroupModalVisible(
                      true,
                      childGroup.id,
                      group.id
                    );
                  }}
                >
                  {`+ ${childGroup.name}`}
                </Button>
              ))}
              {item.items?.map((childItem) => (
                <Button
                  onClick={() => {
                    changeCreateItemModalVisible(true, childItem.id, group.id);
                  }}
                >
                  {`+ ${childItem.name}`}
                </Button>
              ))}
            </Col>
          }
          trigger="hover"
        >
          <i className="fas fa-plus"></i>
        </Popover>
      )}
    </Row>
  );
};

export default TreeNodeTitle;
